module.exports = __webpack_public_path__ + "html/section-different-devices_a2ca0266b02b550f62fc07fcf6ea6d56.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-different-devices.html
// module id = w7UM
// module chunks = 91